<template src="@/pages/CMS/CmsPage.html"/>
<style lang="scss" src="@/pages/CMS/CmsPage.scss" scoped />
<script>
import {
  SfHeading, SfNotification
} from '@storefront-ui/vue';
import OrkLoader from "@/components/Ork/OrkLoader";
import {SfBreadcrumbs} from "@storefront-ui/vue"

import Api from "@/api/Api";
import { configuration } from '@/config/InstanceConfiguration';
import { updateHeadMetadata } from '@/utils/headMetadata';

export default {
  name: "CmsPage",
  components: {
    SfNotification,
    SfHeading,
    OrkLoader,
    SfBreadcrumbs
  },
  data() {
    return {
      loading: true,
      content: null,
      breadcrumbs: null,
      error: false
    };
  },
  created() {
    this.setBreadcrumbs();
  },
  computed: {
    cmsSlug() { return this.$route.name },
    cmsData() {
      return [
        ...(configuration.footer.menuCol1?.items || []),
        ...(configuration.footer.menuCol2?.items || []),
        ...(configuration.footer.menuCol3?.items || [])
      ].find(item => item.slug === this.cmsSlug)
    },
    cmsI18nSlug() { return this.cmsData.i18nSlug || this.cmsData.slug },
    cmsMoqSlug() { return this.cmsData.moqSlug || this.cmsData.slug }
  },
  watch: {
    $route: {
      handler: function(to, from) {
        if (to.name !== from?.name) {
          this.getPageContent().then(() => this.scrollToHash())
        } else {
          this.scrollToHash()
        }
      },
      immediate: true
    }
  },
  methods: {
    setBreadcrumbs() {
      this.breadcrumbs = [
        { text: this.$i18n.t('breadcrumb.home'),          link: '/' },
        { text: this.$i18n.t('cms.' + this.cmsI18nSlug),  link: ''  }
      ];
    },
    getPageContent() {
      if (!this.cmsSlug) return Promise.reject("no slug defined");

      this.loading = true;
      return Api.marketing.getContentPage(this.cmsMoqSlug)
          .then(data => {
            this.content = data;
            updateHeadMetadata({
              title: data.seo.title || this.content.title,
              description: data.seo.description
            })
            this.error = false;
          })
          .catch(err => {
            console.error(err);
            this.error = true;
          })
          .finally(() => this.loading = false)
    },
    scrollToHash() {
      var section = this.$router.currentRoute.hash.replace("#", "");
      if (section) {
        this.$nextTick(() => window.document.getElementById(section)?.scrollIntoView({
          behavior: 'smooth',
          block: 'nearest'
        }));
      }
    }
  }
};
</script>